import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import VueI18n from 'vue-i18n'
import ru from 'vuetify/es5/locale/ru'
import en from 'vuetify/es5/locale/en'
import az from 'vuetify/es5/locale/az'


Vue.use(Vuetify);
Vue.use(VueI18n);


const opts = {
    icons: {
        iconfont: 'mdiSvg'
    },
    lang: {
        locales: { ru, en, az},
        current: 'ru',
    },
};



export default new Vuetify(opts);

